module.exports = __webpack_public_path__ + "static/media/organica.c0279a08.png";